// extracted by mini-css-extract-plugin
export default {"LanguageSelector":"styles_LanguageSelector__6+kDo"};